import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../services/maintenance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrgMappingLookupService } from './services/org-mapping-lookup.service';
import { tap } from 'rxjs/operators';
import { OrgMappingLookup } from 'src/app/client-api.service';
import { TableButton, TableColumn } from 'src/app/shared/tcc-ui/tables';

@Component({
  selector: 'app-org-mapping-lookup',
  templateUrl: './org-mapping-lookup.component.html',
  styleUrls: ['./org-mapping-lookup.component.scss']
})
export class OrgMappingLookupComponent implements OnInit {
  
  allOrgMappingLookups: OrgMappingLookup[] | undefined;
  buttons: TableButton<any>[] | undefined;
  columns: TableColumn<OrgMappingLookup>[] | undefined;
  state: 'initializing' | 'loading' | 'ready' | 'saving';

  orgMappingLookups$ = this.orgMappingLookupService.orgMappingLookups$;

  constructor(private maintenanceService: MaintenanceService,
              private orgMappingLookupService: OrgMappingLookupService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.state = 'initializing';
    this.columns = [
      { title: 'Id', name: 'id' },
      { title: 'Name', name: 'name' },
      { title: 'Meta', name: 'meta' }
    ];

    this.buttons = [
      {
        data: 'editOrgMappingLookupRecord',
        iconClass: 'fas fa-pencil-alt',
        hidden: false,
        buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
        tooltip: 'Edit Org Mapping Lookup Record'
      },
      {
        data: 'deleteOrgMappingLookupRecord',
        iconClass: 'fas fa-trash-alt',
        hidden: false,
        buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
        tooltip: 'Delete Org Mapping Lookup Record'
      }
    ];
  }

  ngOnInit(): void {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.state = 'loading';
    this.orgMappingLookupService.setOrgMappingLookups();
    this.orgMappingLookups$.pipe(
      tap((o) => {        
        this.state = 'ready';
        this.allOrgMappingLookups = o;
      })
    ).subscribe();
  }

  deleteOrgMappingLookup(id: number) {
    if(confirm('Are you sure you want to delete this Org Mapping Lookup?')) {
      this.state = 'loading';
      this.orgMappingLookupService.deleteOrgMappingLookup(id)
        .subscribe(
          res => {
            this.orgMappingLookupService.setOrgMappingLookups();
            this.maintenanceService.setMaintenanceComponenetPanelSize('large');
            this.state = 'ready';
          },
          err => {
            this.state = 'ready';
            alert('Error deleting Org Mapping Lookup');
            this.maintenanceService.setMaintenanceComponenetPanelSize('large');
          }
        );
    }
  }

  openOrgMappingLookupUpsertPanel(id: number) {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.router.navigate(['upsert-org-mapping-lookup/', id], { relativeTo: this.activatedRoute });
  }

  rowClicked(event: any) {
    if (event.button) {
      if (event.button.data === 'editOrgMappingLookupRecord') {
        this.maintenanceService.setMaintenanceComponenetPanelSize('large');
        this.openOrgMappingLookupUpsertPanel(event.row?.id);
      }
      else if (event.button.data === 'deleteOrgMappingLookupRecord') {
        this.deleteOrgMappingLookup(event.row?.id);
      }
    }
  }
}
